export const FALLBACK_AI_OPTIONS = {
  providers: [
    {
      id: 'openai',
      label: 'OpenAI',
      models: [
        { id: 'gpt-4o-mini', label: 'GPT-4o mini (fast and economical)' },
        { id: 'gpt-4o', label: 'GPT-4o (higher accuracy)' },
        { id: 'gpt-4.1-mini', label: 'GPT-4.1 mini' },
        { id: 'gpt-4.1', label: 'GPT-4.1' },
      ],
    },
    {
      id: 'anthropic',
      label: 'Claude',
      models: [
        { id: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5 (fast and economical)' },
        { id: 'claude-3-5-sonnet-20241022', label: 'Claude 3.5 Sonnet' },
        { id: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6 (higher accuracy)' },
      ],
    },
    {
      id: 'openrouter',
      label: 'OpenRouter',
      models: [
        { id: 'openai/gpt-4o-mini', label: 'OpenAI GPT-4o mini via OpenRouter' },
        { id: 'openai/gpt-4o', label: 'OpenAI GPT-4o via OpenRouter' },
        { id: 'anthropic/claude-3.5-haiku', label: 'Anthropic Claude 3.5 Haiku via OpenRouter' },
        { id: 'anthropic/claude-3.5-sonnet', label: 'Anthropic Claude 3.5 Sonnet via OpenRouter' },
      ],
    },
  ],
}

export function getProviderOptions(options) {
  return options?.providers ?? FALLBACK_AI_OPTIONS.providers
}

export function resolveProviderLabel(options, providerId) {
  return getProviderOptions(options).find((item) => item.id === providerId)?.label ?? providerId
}

export function resolveModelLabel(options, providerId, modelId) {
  if (!modelId) return 'Not set'
  const provider = getProviderOptions(options).find((item) => item.id === providerId)
  const model = provider?.models.find((item) => item.id === modelId)
  return model?.label ?? modelId
}

export function getDefaultModelForProvider(options, providerId) {
  const provider = getProviderOptions(options).find((item) => item.id === providerId)
  return provider?.models[0]?.id ?? ''
}
